import { Box, Typography } from "@mui/material";
import * as React from "react";
import { Menu } from "react-admin";

export const UserSection=({user})=>{


    return (<Box>
      <Box sx={{ px: 1, py: 1 }}>
        <Box
          sx={{
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.04)',
            // cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            borderRadius: 1,
            color:'grey.500',
          }}
        >
          <Box sx={{ textAlign: 'center', mx:'auto' }}>
            {user && <>
                <Typography
                color="inherit"
                variant="h6"
                >
                {user?.first_name + " " + user?.last_name}
                </Typography>
                <Typography
                color="inherit"
                variant="body2"
                style={{ fontWeight: 600 }}
                >
                {user?.email}
                </Typography>
                <Box sx={{display:'flex', flexDirection: 'column', pt: 2}}>
                    <Typography
                    color="inherit"
                    variant="body2"
                    >
                    Logged in as:
                    </Typography>
                    <Typography
                        color="inherit"
                        variant="body2"
                        sx={{ fontWeight: 600, wordWrap: 'normal', pl:1 }}
                    >
                        {user?.role?.name}
                    </Typography>
                </Box>
            </>}
          </Box>
        </Box>
      </Box>
    </Box>);
  }